import { render, staticRenderFns } from "./serive-1.vue?vue&type=template&id=45ca2a85&scoped=true"
import script from "./serive-1.vue?vue&type=script&lang=js"
export * from "./serive-1.vue?vue&type=script&lang=js"
import style0 from "./serive-1.vue?vue&type=style&index=0&id=45ca2a85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca2a85",
  null
  
)

export default component.exports